import { OverlayViewF } from "@react-google-maps/api";
import MapLocationIcon from "components/icons-svg/MapLocationIcon";
import { useAppSelector } from "stores/hooks";
import { selectSearchLatLng } from "stores/search/searchSlice";
const ActualSearchLocationPin = () => {
  const latlng = useAppSelector(selectSearchLatLng);
  return <>
      <OverlayViewF mapPaneName={"overlayMouseTarget"} position={latlng} zIndex={10} data-sentry-element="OverlayViewF" data-sentry-source-file="ActualSearchLocationPin.tsx">
        <MapLocationIcon ariaLabel='mapLocationIconTitle' iconTitle='Map Location Icon' data-sentry-element="MapLocationIcon" data-sentry-source-file="ActualSearchLocationPin.tsx" />
      </OverlayViewF>
    </>;
};
export default ActualSearchLocationPin;